import ReplacementsPage from './ReplacementsPage.vue';
import ReplacementsTable from './ReplacementsTable.vue';

export * from './types';
export {
    ReplacementsPage as default,
    ReplacementsPage,
    ReplacementsTable,
};
